<template>
  <div class="logo" :class="inline ? 'inline' : ''">
    <img
      src="../assets/logo-white.png"
      alt="kiosk access portal"
      class="img-responsive"
    />
    <span class="logo-text">KIOSK</span>
  </div>
</template>

<script>
export default {
  name: "HeaderLogo",
  props: {
    inline: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
//@import "../custom.scss";
.logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  &.inline {
    flex-direction: row;
    align-items: flex-end;
  }

  .logo-text {
    color: white;
    font-size: 0.8em;
    font-weight: bold;
    line-height: 0.8;
    letter-spacing: 0.0375em;
  }
}
</style>
